import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import _ from "lodash";
import {
  sortableContainer,
  sortableElement,
  sortableHandle,
} from "react-sortable-hoc";
import arrayMove from "array-move";
import { Modal, Row, Col, DropdownButton, Dropdown } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import { fetchEventDetails } from "DashboardUserAction";
import { badgeDefaultStructure } from "BadgeDesignReducer"; // Array of objects
import {
  openBadgeDesignModal,
  setbadgeJson,
  fetchBadgeList,
  addTemplate,
  updateTemplate,
  getSingleBadgerecord,
  togglePrintPreviewModal,
  setSelectedElement,
  handleImageEleModal,
} from "BadgeDesignAction";
import { showError, showSuccess } from "ReduxErrorBar";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import {
  centToInch,
  inchToCent,
  convertToPixel,
  convertToPixelDouble,
} from "BaseFunctions";
import { validateDecimalNums } from "Constants";
import {
  PAGESIZEOPTIONS,
  PAGEDEFAULTSIZE,
  PAGEDEFAULTPADDING,
  BADGESIZEOPTIONS,
  BADGEDEFAULTSIZE,
  BADGEMINWIDTH,
  BADGEMAXWIDTH,
  BADGEMINHEIGHT,
  BADGEMAXHEIGHT,
  DEFAULTFONTSIZE,
  DEFAULTFONTFAMILY,
} from "./badge-constants";
import BadgeTemplateEditorNew from "./editor/badge-template-editor-new";
import ElementList from "./badge-designer-element-item";
import AddImageElemet from "./badge-designer-add-image-element";
import BetaFeature from "BetaFeature";
import LocaleStrings from "Languages";

const DragHandle = sortableHandle(() => (
  <span className="drag-icon">
    <i className="fa fa-bars" aria-hidden="true"></i>
  </span>
));

const SortableItem = sortableElement(
  ({ value, index, handelElementChange }) => (
    <li className="badge-element-list" key={`element_key_${index}`}>
      <DragHandle />
      <ElementList data={value} handelElementChange={handelElementChange} />
    </li>
  )
);

const SortableContainer = sortableContainer(
  ({ items, handelElementChange }) => {
    // console.log("items :- ", items);

    return (
      <ul className="badge-element-list-group">
        {items.map((value, index) => {
          return (
            <SortableItem
              key={`item-${index}`}
              index={index}
              value={value}
              handelElementChange={handelElementChange}
            />
          );
        })}
      </ul>
    );
  }
);

class CreateNewDialog extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      fisrtTime: true,
      draggableElementNotMovied: true,
      isPageCustom: false,
      isBadgeCustom: false,
      update: false,
      boxSize: {
        height: convertToPixelDouble("cm", _.split(BADGEDEFAULTSIZE, "#")[1]),
        width: convertToPixelDouble("cm", _.split(BADGEDEFAULTSIZE, "#")[0]),
      },
      badgeWH: {
        // Only use when user click on set (in cm)
        height: 0,
        width: 0,
      },
      pageWH: {
        // Only use when user click on set (in cm)
        height: 0,
        width: 0,
      },
    };

    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
  }

  componentDidMount() {
    let { session } = this.props;

    this.props.setbadgeJson();
    this.props.fetchEventDetails(session, (callback) => {});
  }

  componentWillReceiveProps(nextProps) {
    if (_.has(nextProps.initialValues, "badgeid") && this.state.fisrtTime) {
      let badgeSizeArry =
        nextProps.initialValues.badge_size === "custom"
          ? _.split(nextProps.initialValues.badge_custom_or_list, "#", 2)
          : _.split(nextProps.initialValues.badge_size, "#", 2);
      let width = badgeSizeArry[0]; // width
      let height = badgeSizeArry[1]; // height

      this.setState({
        boxSize: {
          height: convertToPixelDouble(
            nextProps.initialValues.measurement,
            height
          ),
          width: convertToPixelDouble(
            nextProps.initialValues.measurement,
            width
          ),
        },
        badgeWH: {
          height: height,
          width: width,
        },
        fisrtTime: false,
        isPageCustom: nextProps.initialValues.iscustompage,
        isBadgeCustom: nextProps.initialValues.iscustombadge,
      });
    }
  }

  openModal() {
    this.props.reset();
    this.props.openBadgeDesignModal(true);
  }

  closeModal() {
    this.props.reset(); // Reset form
    this.resetStates();
    this.props.openBadgeDesignModal(false);
    this.props.setSelectedElement(); // Clear selected badge element for style changes
    this.props.getSingleBadgerecord([], false); // First make it clear
    this.props.getSingleBadgerecord(badgeDefaultStructure, false); // then assign default array
  }

  resetStates = () => {
    this.setState({
      loading: false,
      fisrtTime: true,
      draggableElementNotMovied: true,
      isPageCustom: false,
      isBadgeCustom: false,
      boxSize: {
        // converted to pixel
        height: convertToPixelDouble("cm", _.split(BADGEDEFAULTSIZE, "#")[1]),
        width: convertToPixelDouble("cm", _.split(BADGEDEFAULTSIZE, "#")[0]),
      },
      badgeWH: {
        // Only use when user click on set
        height: 0,
        width: 0,
      },
      pageWH: {
        // Only use when user click on set
        height: 0,
        width: 0,
      },
    });
  };

  /* Print preview  */
  printPreview = (props) => {
    this.props.togglePrintPreviewModal(true); //  It will open print preview modal
  };

  /* On badge size change update */
  _handelBadgeSizeChange(e) {
    let badgeSizeVal = e.target.value ? e.target.value : ""; // value ex- 4#3
    let { measurementType } = this.props;

    if (badgeSizeVal === "custom") {
      /* 
        In case will show custom input fields for badge size 
        Note : - Here custome => Custom badge size in centemiter
      */

      // Setting custom page type
      this.setState({ isBadgeCustom: true });
    } else {
      this.setState({ isBadgeCustom: false });

      // set default badge size again || make default for custom badge heigh width
      this.props.change("badge_size", BADGEDEFAULTSIZE);
      this.props.change("badgewidth", "");
      this.props.change("badgeheight", "");
      this.setState({
        boxSize: {
          height: convertToPixelDouble(
            measurementType,
            _.split(BADGEDEFAULTSIZE, "#")[1]
          ),
          width: convertToPixelDouble(
            measurementType,
            _.split(BADGEDEFAULTSIZE, "#")[0]
          ),
        },
        badgeWH: {
          // Only use when user click on set
          height: 0,
          width: 0,
        },
      });

      if (_.size(badgeSizeVal) > 0) {
        // Other than custom and and not null
        let badgeSizeArr = _.split(badgeSizeVal, "#"); // Exapmle [4,3]

        // Check if value present then set state
        this.setState({
          boxSize: {
            height: convertToPixelDouble(measurementType, badgeSizeArr[1]), // first example 3 (W X H)
            width: convertToPixelDouble(measurementType, badgeSizeArr[0]), // first example 4 (W X H)
          },
        });
      }
    }
  }

  /* On badge size change from options */
  _handelPageSizeChange(e) {
    let pageSizeVal = e.target.value ? e.target.value : ""; // value ex- 4#3

    if (pageSizeVal === "custom") {
      // Setting custom page type
      this.setState({ isPageCustom: true });
    } else {
      // Setting custom page type
      this.setState({ isPageCustom: false });
      // set default page size again || make default for custom page heigh width
      this.props.change("pagewidth", "");
      this.props.change("pageheight", "");
      this.setState({
        pageWH: {
          // Will set on type 'No '
          height: 0,
          width: 0,
        },
      });
    }
  }

  /* On badge element check box select deselect */
  _handelBadgeElementChange = (e) => {
    let { templateJson } = this.props;
    // console.log("e", e);

    // On check uncheck make true / false in json [array of object -> in store ]
    if (typeof e === "object") {
      _.map(templateJson, (value, index) => {
        if (_.indexOf(e, value.name) > -1) {
          value.hidden = false;
        } else {
          value.hidden = true;
        }
      });
    }

    this.props.setbadgeJson(templateJson); // Update to store
  };

  // This method is called for element position update, element delete and element add
  _handelDraggableElementChange() {
    this.setState({ draggableElementNotMovied: false });
  }

  /* When user put custom value for badge or page */
  _handelCustomPageValue(e, callFor, fieldFor) {
    // Check call from badge or page
    let valInCm = e.target.value ? parseFloat(e.target.value) : 0;

    if (callFor === "badge") {
      // Badge [ set // Only use when user click on set]
      if (fieldFor === "H") {
        this.setState({
          badgeWH: {
            height: valInCm,
            width: this.state.badgeWH.width,
          },
        });
      }

      if (fieldFor === "W") {
        this.setState({
          badgeWH: {
            height: this.state.badgeWH.height,
            width: valInCm,
          },
        });
      }
    } else if (callFor == "page") {
      //Page [ set // Only use when user click on set]
      if (fieldFor === "H") {
        this.setState({
          pageWH: {
            height: valInCm,
            width: this.state.pageWH.width,
          },
        });
      }

      if (fieldFor === "W") {
        this.setState({
          pageWH: {
            height: this.state.pageWH.height,
            width: valInCm,
          },
        });
      }
    } else {
      // #
    }
  }

  /* Set custom page or badge size */
  onSetCustomSize(e, CallForbtnName) {
    let { measurementType, badgewidth, badgeheight } = this.props;

    if (CallForbtnName === "badge") {
      this.setState({
        boxSize: {
          width: badgewidth
            ? convertToPixelDouble(measurementType, badgewidth)
            : 0,
          height: badgeheight
            ? convertToPixelDouble(measurementType, badgeheight)
            : 0,
        },
      });
    }
  }

  /* Add another custom element On button click */
  addAnotherElement = (type) => {
    // console.log("type :- ", type);
    let { templateJson } = this.props;
    var newInputObjectToPush = {};

    if (type === "text") {
      let LastIndex = _.findLastIndex(templateJson, ["htmlType", "input"]);

      let newLevelVal = 1;
      let newDisplayOrder = templateJson.length;
      if (LastIndex > -1) {
        newLevelVal = parseInt(templateJson[LastIndex].levelVal) + 1;
        newDisplayOrder = parseInt(templateJson[LastIndex].displayOrder) + 1;
      }

      newInputObjectToPush = {
        id: "input_" + newLevelVal,
        name: "#input_" + newLevelVal,
        checkboxLabel: LocaleStrings.badge_element_input_type,
        hidden: true,
        handle: ".handle-input_" + newLevelVal + " move",
        scale: 1,
        x: 130,
        y: 183,
        textValue: "",
        iscustom: true,
        label: true,
        levelVal: newLevelVal,
        style: {
          width: "max-content",
          height: "max-content",
          textAlign: "center",
          textDecoration: "",
          fontWeight: "normal",
          fontSize: DEFAULTFONTSIZE,
          fontFamily: DEFAULTFONTFAMILY,
          fontStyle: "",
          position: "absolute",
        },
        htmlType: "input",
        displayOrder: newDisplayOrder,
      };

      templateJson.push(newInputObjectToPush);

      this.props.setbadgeJson(templateJson); // Update to store
      this._handelDraggableElementChange(); // detect element change for submit button disable
      this.setState({ update: !this.state.update }); // Used to re-render the DOM
    } else if (type === "image") {
      this.props.handleImageEleModal({ show: true });
    }
  };

  imageUploadCallback = (data) => {
    // console.log("callback data :- ", data);
    let { templateJson, badgeSize, badgewidth, badgeheight, measurementType } =
      this.props;

    let badgeWidth = 0;
    let badgeHeight = 0;
    if (badgeSize === "custom") {
      badgeWidth = convertToPixel(
        measurementType,
        badgewidth && badgewidth > 0 ? badgewidth : 0
      );
      badgeHeight = convertToPixel(
        measurementType,
        badgeheight && badgeheight > 0 ? badgeheight : 0
      );
    } else {
      var badgeSizeArr = _.split(badgeSize, "#");
      // console.log("badgeSizeArr :- ", badgeSizeArr);

      if (!isNaN(badgeSizeArr[0])) {
        badgeWidth = convertToPixel(measurementType, badgeSizeArr[0]);
        badgeHeight = convertToPixel(measurementType, badgeSizeArr[1]);
      }
    }
    // console.log("badgeWidth :- ", badgeWidth);
    // console.log("badgeHeight :- ", badgeHeight);

    if (!_.isEmpty(data)) {
      let width = data.width ? data.width : 100;
      let height = data.height ? data.height : 100;
      // console.log("width :- ", width);
      // console.log("height :- ", height);

      width = (width > badgeWidth && badgeWidth > 0 ? badgeWidth : width) * 2; // double is only to display as preview
      height =
        (height > badgeHeight && badgeHeight > 0 ? badgeHeight : height) * 2; // double is only to display as preview

      let displayOrder = "";
      if (!_.isEmpty(data.existing)) {
        // Update existing image element
        let arrIndex = _.findIndex(templateJson, function (o) {
          return o.id == data.existing.id;
        });
        templateJson[arrIndex].imageValue = data.path ? data.path : "";
        templateJson[arrIndex].hidden = false;
        templateJson[arrIndex].style.width = width;
        templateJson[arrIndex].style.height = height;

        displayOrder = data.existing.displayOrder;
      } else {
        // Add new image emelent
        let LastIndex = _.findLastIndex(templateJson, (e) => {
          return e.iscustom === true && e.htmlType === "image";
        });
        // console.log("templateJson :- ", templateJson);
        // console.log("LastIndex :- ", LastIndex);
        let newLevelVal = 1;
        let newDisplayOrder = templateJson.length;
        if (LastIndex > -1) {
          newLevelVal = parseInt(templateJson[LastIndex].levelVal) + 1;
          newDisplayOrder = parseInt(templateJson[LastIndex].displayOrder) + 1;
        }
        let newInputObjectToPush = {
          id: "image_" + newLevelVal,
          name: "#image_" + newLevelVal,
          checkboxLabel: LocaleStrings.badge_element_image_type,
          hidden: false,
          handle: ".handle-image_" + newLevelVal + " move",
          scale: 1,
          x: 0,
          y: 0,
          imageValue: data.path ? data.path : "",
          iscustom: true,
          label: true,
          levelVal: newLevelVal,
          style: {
            width: width,
            height: height,
            position: "absolute",
          },
          htmlType: "image",
          displayOrder: newDisplayOrder,
        };

        templateJson.push(newInputObjectToPush);
        displayOrder = newDisplayOrder;
      }

      setTimeout(() => {
        let elements = document.getElementById(
          `badge_elements[${displayOrder}]`
        );
        elements.click();
        // console.log("elements :- ", elements);
      }, 500);

      this.props.setbadgeJson(templateJson); // Update to store
      this._handelDraggableElementChange(); // detect element change for submit button disable
      this.setState({ update: !this.state.update }); // Used to re-render the DOM
    }
  };

  onSortEnd = ({ oldIndex, newIndex }) => {
    var arrAvailable = this.props.templateJson;

    arrAvailable = arrayMove(arrAvailable, oldIndex, newIndex);
    // console.log("arrAvailable :- ", arrAvailable);

    // Just map the array and reset the taborder as now taborder is same as the object position
    var newArrAvailable = [];
    arrAvailable.map((value, index) => {
      newArrAvailable.push({ ...value, displayOrder: index });
    });
    // console.log("newArrAvailable :- ", newArrAvailable);

    this._handelDraggableElementChange(); // detect element change for submit button disable
    this.props.setbadgeJson(newArrAvailable);
  };

  onFormSubmit(values) {
    let { templateJson, session, showError } = this.props;
    // console.log("values :- ", values);

    // Closing all the opened input field
    _.map(templateJson, (item) => {
      if (item.htmlType === "input") {
        item.label = true;
      }
    });

    /* Custom validation */

    // Badge element validation
    if (_.size(values.badge_elements) === 0) {
      showError(LocaleStrings.badge_element_choose_atleast_one);
      return false;
    }

    // Badge page should be less than page size validation
    let pagewidth = 0;
    let pageheight = 0;

    let badgewidth = 0;
    let badgeheight = 0;

    if (_.has(values, "page_size") && values.page_size === "custom") {
      // Custome page size exist
      pagewidth =
        typeof values.pagewidth === "string"
          ? parseFloat(values.pagewidth)
          : values.pagewidth;
      pageheight =
        typeof values.pageheight === "string"
          ? parseFloat(values.pageheight)
          : values.pageheight;
    } else {
      let pageSizeArr = _.split(values.page_size, "#"); // Exapmle [4,3]
      pagewidth =
        typeof pageSizeArr[0] === "string"
          ? parseFloat(pageSizeArr[0])
          : pageSizeArr[0];
      pageheight =
        typeof pageSizeArr[1] === "string"
          ? parseFloat(pageSizeArr[1])
          : pageSizeArr[1];
    }

    //if (_.has(values, "badge_custom_or_list")) {
    if (_.has(values, "badge_size") && values.badge_size === "custom") {
      // Custome badge size exist
      badgewidth =
        typeof values.badgewidth === "string"
          ? parseFloat(values.badgewidth)
          : values.badgewidth;
      badgeheight =
        typeof values.badgeheight === "string"
          ? parseFloat(values.badgeheight)
          : values.badgeheight;
    } else {
      let badgeSizeArr = _.split(values.badge_size, "#"); // Exapmle [4,3]
      badgewidth =
        typeof badgeSizeArr[0] === "string"
          ? parseFloat(badgeSizeArr[0])
          : badgeSizeArr[0];
      badgeheight =
        typeof badgeSizeArr[1] === "string"
          ? parseFloat(badgeSizeArr[1])
          : badgeSizeArr[1];
    }

    // if (badgewidth >= pagewidth || badgeheight >= pageheight) {
    //   showError(LocaleStrings.dashboard_badgedesign_inappropriate_size_error);
    //   return false;
    // }

    // User category related section start
    let res = null;
    let userCat = values.usercategory;
    if (userCat && Array.isArray(userCat) && userCat.length > 0) {
      let tags = _.map(userCat, (el) => {
        return el.value;
      });

      var othrcat = tags.join(",");
      res = othrcat;
    } else if (userCat && !Array.isArray(userCat)) {
      res = userCat;
    }

    // Add
    let submitObject = {
      eventid: this.props.session.eventid,
      badgename: values.badgename,
      measurement: values.measurement,
      badge_size:
        values.badge_size !== "custom"
          ? values.badge_size
          : values.badgewidth + "#" + values.badgeheight,
      // page_size:
      //   values.page_size !== "custom"
      //     ? values.page_size
      //     : values.pagewidth + "#" + values.pageheight,
      // page_padding:
      //   values.page_padding_top + "#0#0#" + values.page_padding_left,

      //  updated on 20-09-2022. Default page size will be badge size and padding will be 0 as now we will allow only one badge print at a time. If we will print page wise then uncomment above section and comment this
      page_size:
        values.badge_size !== "custom"
          ? values.badge_size
          : values.badgewidth + "#" + values.badgeheight,
      page_padding: "0#0#0#0",

      badge_elements: values.badge_elements.toString(values.badge_elements),
      template: JSON.stringify(templateJson),
      usercategory: res,
    };

    // Insert db related value for 'Page default/custom' field
    // submitObject["iscustompage"] = values.page_size === "custom" ? 1 : 0;
    submitObject["iscustompage"] = values.badge_size === "custom" ? 1 : 0; //  updated on 20-09-2022. Default page size will be badge size and iscustompage will be iscustombadge as now we will allow only one badge print at a time. If we will print page wise then uncomment above section and comment this

    // Insert db related value for 'Badge default/custom' field
    submitObject["iscustombadge"] = values.badge_size === "custom" ? 1 : 0;

    // console.log("submitObject :- ", submitObject);

    this.setState({ loading: true }); // Start button loader
    if (_.has(values, "badgeid")) {
      // Update
      submitObject.badgeid = values.badgeid;

      this.props.updateTemplate(session, submitObject, (response) => {
        if (response.success) {
          this.props.showSuccess(
            LocaleStrings.dashboard_badgedesign_form_update_success
          );
          this.closeModal();
          this.props.finishOperationsCallback();
        }
        this.setState({ loading: false }); // Start button loader
      });
    } else {
      // Add
      this.props.addTemplate(session, submitObject, (response) => {
        if (response.success) {
          this.props.showSuccess(
            LocaleStrings.dashboard_badgedesign_form_add_uccess
          );
          this.closeModal();
          this.props.finishOperationsCallback();
        }
        this.setState({ loading: false }); // Start button loader
      });
    }
  }

  handleCalculationType = (e) => {
    let type = e.target.value;
    let { badgeSize, badgewidth, badgeheight } = this.props;

    if (badgeSize === "custom") {
      let BW = 0;
      let BH = 0;
      if (badgewidth > 0) {
        let w =
          type === "inch" ? centToInch(badgewidth) : inchToCent(badgewidth);
        BW = w > 0 ? convertToPixelDouble(type, w) : 0;

        this.props.change("badgewidth", w.toFixed(2));
      }

      if (badgeheight > 0) {
        let h =
          type === "inch" ? centToInch(badgeheight) : inchToCent(badgeheight);
        BH = h > 0 ? convertToPixelDouble(type, h) : 0;

        this.props.change("badgeheight", h.toFixed(2));
      }

      this.setState({
        boxSize: { height: BH, width: BW },
      });
    } else {
      // set default badge size again || make default for custom badge heigh width
      this.setState({
        boxSize: {
          height: convertToPixelDouble(type, _.split(BADGEDEFAULTSIZE, "#")[1]),
          width: convertToPixelDouble(type, _.split(BADGEDEFAULTSIZE, "#")[0]),
        },
      });

      if (_.size(badgeSize) > 0) {
        // Other than custom and and not null
        let badgeSizeArr = _.split(badgeSize, "#"); // Exapmle [4,3]

        // Check if value present then set state
        this.setState({
          boxSize: {
            height: convertToPixelDouble(type, badgeSizeArr[1]), // first example 3 (W X H)
            width: convertToPixelDouble(type, badgeSizeArr[0]), // first example 4 (W X H)
          },
        });
      }
    }
  };

  render() {
    var {
      handleSubmit,
      pristine,
      submitting,
      invalid,
      isBadgeDesignModalOpen,
      initialValues,
      editMode,
      templateJson,
      badgewidth,
      badgeheight,
      imageElementModal,
      userCategoryList,
      dashboardAllBadgeList,
      measurementType,
    } = this.props;
    let {
      boxSize,
      loading,
      draggableElementNotMovied,
      isPageCustom,
      isBadgeCustom,
    } = this.state;

    // Custom badge element list badge elements
    let badgeElementsOptions = [];
    let levelI = 0;
    _.forEach(templateJson, (val, i) => {
      if (val.htmlType === "input") {
        levelI++;
      }
      let text =
        val.htmlType === "input"
          ? val.checkboxLabel + ` (${levelI})`
          : val.checkboxLabel;

      let optionObj = { text: text, value: val.name };
      badgeElementsOptions.push(optionObj);
    });

    let custPristine = true;

    if (editMode) {
      custPristine =
        pristine === false || draggableElementNotMovied === false
          ? false
          : true;
    } else {
      custPristine = pristine;
    }

    let getUsedCate = [];
    if (dashboardAllBadgeList.data) {
      let getUsed = [];
      dashboardAllBadgeList.data.map((a) => {
        if (editMode) {
          if (
            initialValues.badgeid !== a.badgeid &&
            a.usercategory !== null &&
            a.usercategory !== ""
          )
            getUsed.push(a.usercategory);
        } else {
          if (a.usercategory !== null && a.usercategory !== "")
            getUsed.push(a.usercategory);
        }
      });
      getUsedCate = getUsed.join(",").split(",");
    }

    // console.log("getUsedCate :- ", getUsedCate);

    var categories = [];
    if (
      userCategoryList &&
      userCategoryList.data &&
      userCategoryList.data.length > 0
    ) {
      userCategoryList.data.forEach((item, index) => {
        if (!getUsedCate.includes(item.id.toString())) {
          var obj = {
            label: item.groupname,
            // name: item.groupname,
            value: item.id.toString(),
          };
          categories.push(obj);
        }
      });
    }

    let badgeCustomBtnSet = true;
    if (badgewidth && badgeheight) {
      if (
        badgewidth < BADGEMINWIDTH ||
        badgewidth > BADGEMAXWIDTH ||
        badgeheight < BADGEMINHEIGHT ||
        badgeheight > BADGEMAXHEIGHT
      ) {
        badgeCustomBtnSet = true;
      } else {
        badgeCustomBtnSet = false;
      }
    }

    // console.log("dashboardAllBadgeList :- ", dashboardAllBadgeList);
    // console.log("categories :- ", categories);
    // console.log("templateJson :- ", templateJson);
    // console.log("initialValues :- ", initialValues);
    // console.log("boxSize :- ", boxSize);

    return (
      <div>
        <span className="">
          <button
            type="button"
            className="btn btn-custom-blue"
            onClick={this.openModal}
          >
            <img
              style={{ paddingRight: 8, paddingBottom: 3 }}
              src="../../style/images/header-icons/plus.png"
            ></img>
            {LocaleStrings.button_create_new}
          </button>
        </span>
        <div>
          <Modal
            className="modal-container custom-full-screen-modal badge-modal"
            dialogClassName="modal-xl"
            show={isBadgeDesignModalOpen}
            onHide={this.closeModal}
            animation={true}
          >
            <form
              onSubmit={handleSubmit(this.onFormSubmit.bind(this))}
              encType="multipart/form-data"
            >
              <Modal.Header>
                <div className="import-modal-title">
                  {editMode
                    ? LocaleStrings.dashboard_badgedesign_edit_modal_header
                    : LocaleStrings.dashboard_badgedesign_modal_header}
                </div>
                <div className="vertical-align-center">
                  {/* <button
                    type="button"
                    className="btn btn-custom-blue btn btn-primary ml-2"
                    onClick={() => this.printPreview()}
                  >
                    {LocaleStrings.dashboard_badgedesign_preview}{" "}
                    <i className="fa fa-eye" aria-hidden="true"></i>
                  </button> */}
                  <Button
                    className="btn btn-custom-blue mr-10"
                    bsStyle=""
                    loading={loading}
                    disabled={custPristine || invalid || submitting}
                    type="submit"
                  >
                    {LocaleStrings.button_save}
                  </Button>
                  <button
                    type="button"
                    className="i-custom-cross-popup pull-right"
                    onClick={() => this.closeModal()}
                  >
                    <img
                      className="i-custom-small"
                      src="../../style/images/custom-icons/cross-black.png"
                    />
                  </button>
                </div>
              </Modal.Header>
              <Modal.Body>
                <Row className="m-0 h-full">
                  <Col
                    sm={3}
                    className="border-right"
                    style={{ backgroundColor: "white" }}
                  >
                    <div className="badge-modal-element-section">
                      {/* Badge name */}
                      <Field
                        name="badgename"
                        label={
                          LocaleStrings.dashboard_badgedesign_form_label_badge_name
                        }
                        placeholder={
                          LocaleStrings.dashboard_badgedesign_form_badge_name
                        }
                        type="text"
                        mandatory="true"
                        labelposition={LABEL_POSITION_TOP}
                        component={this.renderFieldText}
                      />

                      <Field
                        name="usercategory"
                        label={
                          LocaleStrings.dashboard_badgedesign_form_label_linkcategory
                        }
                        placeholder={
                          LocaleStrings.dashboard_badgedesign_form_ph_linkcategory
                        }
                        labelinfo={
                          LocaleStrings.dashboard_badgedesign_form_labelinfo_linkcategory
                        }
                        bsClass="badge-userCategory"
                        component={this.renderAutoComplete}
                        mandatory="false"
                        isMulti={true}
                        options={categories}
                        labelKey="label"
                        valueKey="value"
                      />

                      {/* Page size */}
                      {/* <Field
                        name={"page_size"}
                        label={
                          LocaleStrings.dashboard_badgedesign_form_label_page_size
                        }
                        placeholder={
                          LocaleStrings.dashboard_badgedesign_form_page_size
                        }
                        component={this.renderSelect}
                        mandatory="true"
                        opts={PAGESIZEOPTIONS}
                        onChange={(e) => this._handelPageSizeChange(e)}
                        labelposition={LABEL_POSITION_TOP}
                      />
                      Toggle between custom and default page // comment this once
                      page size option enabled
                      {isPageCustom ? (
                        <div className="custom-badge-size-box mb-10">
                          <Row>
                            <Col sm={12}>
                              <label className="control-label-top col-sm-12">
                                {
                                  LocaleStrings.dashboard_badgedesign_form_label_custom_page_size
                                }
                                <span className="label-mandatory">*</span>
                              </label>
                            </Col>
                            <Col sm={6}>
                              <Field
                                name="pagewidth"
                                placeholder={
                                  LocaleStrings.dashboard_badgedesign_form_ph_custom_page_size
                                }
                                type="number"
                                mandatory="true"
                                min="8.89"
                                labelposition={LABEL_POSITION_TOP}
                                component={this.renderFieldText}
                                onChange={(e) =>
                                  this._handelCustomPageValue(e, "page", "W")
                                }
                              />
                            </Col>
                            <Col sm={6}>
                              <Field
                                name="pageheight"
                                placeholder={
                                  LocaleStrings.dashboard_badgedesign_form_ph_custom_page_size
                                }
                                type="number"
                                mandatory="true"
                                min="4.44"
                                labelposition={LABEL_POSITION_TOP}
                                component={this.renderFieldText}
                                onChange={(e) =>
                                  this._handelCustomPageValue(e, "page", "H")
                                }
                              />
                            </Col>
                          </Row>
                        </div>
                      ) : (
                        ""
                      )} */}

                      {/* Page Padding*/}
                      {/* <Row>
                        <Col sm={12}>
                          <label className="control-label-top">
                            {
                              LocaleStrings.dashboard_badgedesign_form_label_page_padding
                            }
                            <span className="label-mandatory">*</span>
                          </label>
                        </Col>
                        <Col sm={6}>
                          <Field
                            name="page_padding_top"
                            label=""
                            placeholder={
                              LocaleStrings.dashboard_badgedesign_form_ph_page_padding_top
                            }
                            type="number"
                            mandatory="true"
                            min="0"
                            labelposition={LABEL_POSITION_TOP}
                            component={this.renderFieldText}
                          />
                        </Col>
                        <Col sm={6}>
                          <Field
                            name="page_padding_left"
                            label=""
                            placeholder={
                              LocaleStrings.dashboard_badgedesign_form_ph_page_padding_left
                            }
                            type="number"
                            mandatory="true"
                            min="0"
                            labelposition={LABEL_POSITION_TOP}
                            component={this.renderFieldText}
                          />
                        </Col>
                      </Row> */}

                      <Row>
                        <Col sm={6}>
                          <Field
                            label={LocaleStrings.cm}
                            name="measurement"
                            type="radio"
                            value="cm"
                            component={this.renderFieldRadio}
                            onChange={this.handleCalculationType}
                          />
                        </Col>
                        <Col sm={6}>
                          <Field
                            label={LocaleStrings.inch}
                            name="measurement"
                            type="radio"
                            value="inch"
                            component={this.renderFieldRadio}
                            onChange={this.handleCalculationType}
                          />
                        </Col>
                      </Row>

                      {/* Badge size */}
                      <Field
                        name={"badge_size"}
                        label={
                          LocaleStrings.dashboard_badgedesign_form_label_badge_size
                        }
                        placeholder={
                          LocaleStrings.dashboard_badgedesign_form_badge_size
                        }
                        component={this.renderSelect}
                        mandatory="true"
                        opts={BADGESIZEOPTIONS}
                        onChange={(e) => this._handelBadgeSizeChange(e)}
                        labelposition={LABEL_POSITION_TOP}
                      />
                      {/* Toggle between custom and default Badge */}
                      {isBadgeCustom ? (
                        <div className="custom-badge-size-box mb-10">
                          <Row>
                            <Col sm={12}>
                              <label className="control-label-top col-sm-12">
                                {
                                  LocaleStrings.dashboard_badgedesign_form_label_custon_badge_size
                                }
                                <span className="label-mandatory">*</span>
                              </label>
                            </Col>
                            <div className="d-flex gap-1">
                              <Col sm={5}>
                                <Field
                                  name="badgewidth"
                                  placeholder={
                                    LocaleStrings.dashboard_badgedesign_form_ph_custon_badge_size
                                  }
                                  type="number"
                                  mandatory="true"
                                  min={BADGEMINWIDTH}
                                  max={BADGEMAXWIDTH}
                                  labelposition={LABEL_POSITION_TOP}
                                  component={this.renderFieldText}
                                  onChange={(e) =>
                                    this._handelCustomPageValue(e, "badge", "W")
                                  }
                                />
                              </Col>
                              <Col sm={5}>
                                <Field
                                  name="badgeheight"
                                  placeholder={
                                    LocaleStrings.dashboard_badgedesign_form_ph_custon_badge_size
                                  }
                                  type="number"
                                  mandatory="true"
                                  min={BADGEMINHEIGHT}
                                  max={BADGEMAXHEIGHT}
                                  labelposition={LABEL_POSITION_TOP}
                                  component={this.renderFieldText}
                                  onChange={(e) =>
                                    this._handelCustomPageValue(e, "badge", "H")
                                  }
                                />
                              </Col>
                              <Col sm={2}>
                                <Button
                                  bsStyle=""
                                  type="button"
                                  className="btn btn-custom-blue"
                                  onClick={(e) =>
                                    badgeCustomBtnSet
                                      ? null
                                      : this.onSetCustomSize(e, "badge")
                                  }
                                  disabled={badgeCustomBtnSet}
                                  // disabled={
                                  //   !badgewidth ||
                                  //   !badgewidth ||
                                  //   badgewidth < BADGEMINWIDTH ||
                                  //   badgewidth > BADGEMAXWIDTH ||
                                  //   badgeheight < BADGEMINHEIGHT ||
                                  //   badgeheight > BADGEMAXHEIGHT
                                  // }
                                >
                                  {LocaleStrings.set}
                                </Button>
                              </Col>
                            </div>
                          </Row>
                        </div>
                      ) : (
                        ""
                      )}

                      {/* Add another extra fields */}
                      <div className="dropdown-btn-container vertical-align-center-justify-right">
                        <DropdownButton
                          className="dropdown-custom-white-md badge-add-new-element-dropdown"
                          title={
                            <>
                              <i className="fa fa-plus" aria-hidden="true"></i>
                              <div>{LocaleStrings.button_add}</div>
                            </>
                          }
                          key="down"
                          id="dropdown-basic-md"
                          nocaret="true"
                        >
                          <Dropdown.Item
                            eventKey="addtextfield"
                            style={{ paddingBottom: 10, paddingTop: 8 }}
                            onClick={() => this.addAnotherElement("text")}
                          >
                            <i
                              className="fa fa-text-width pr-10"
                              aria-hidden="true"
                            ></i>
                            {
                              LocaleStrings.dashboard_badgedesign_botton_custom_add_text_field
                            }
                          </Dropdown.Item>

                          <Dropdown.Item
                            eventKey="addimagefield"
                            style={{ paddingBottom: 10 }}
                            onClick={() => this.addAnotherElement("image")}
                          >
                            <i
                              className="fa fa-picture-o pr-10"
                              aria-hidden="true"
                            ></i>
                            {
                              LocaleStrings.dashboard_badgedesign_botton_custom_add_image_field
                            }
                            <span className="ps-1">
                              <BetaFeature />
                            </span>
                          </Dropdown.Item>
                        </DropdownButton>
                      </div>
                      {/* <Field
                        name={"badge_elements"}
                        label={
                          LocaleStrings.dashboard_badgedesign_form_badge_elements
                        }
                        type="checkbox"
                        component={this.renderCheckbox}
                        mandatory="true"
                        opts={badgeElementsOptions}
                        onChange={this._handelBadgeElementChange}
                      /> */}
                      <div className="custom-text1-primary-medium">
                        {
                          LocaleStrings.dashboard_badgedesign_form_badge_elements
                        }
                      </div>
                      <div className="custom-text1-theme-normal mb-3">
                        {
                          LocaleStrings.dashboard_badgedesign_form_badge_elements_note1
                        }
                      </div>
                      <Field
                        name={"badge_elements"}
                        type="checkbox"
                        component={this.renderHiddenCheckbox}
                        opts={badgeElementsOptions}
                      />
                      <SortableContainer
                        items={templateJson}
                        onSortEnd={this.onSortEnd}
                        useDragHandle
                        handelElementChange={this._handelDraggableElementChange.bind(
                          this
                        )}
                      />
                    </div>
                  </Col>
                  <Col sm={9} className="px-0">
                    {/* Main editor */}
                    <BadgeTemplateEditorNew
                      measurementType={measurementType}
                      boxSize={boxSize}
                      draggableElementNotMovied={
                        this.state.draggableElementNotMovied
                      }
                      _handelDraggableElementChange={this._handelDraggableElementChange.bind(
                        this
                      )}
                    />
                  </Col>
                </Row>

                {/* Image badge element modal */}
                {imageElementModal.show ? (
                  <AddImageElemet imageCallback={this.imageUploadCallback} />
                ) : (
                  ""
                )}
              </Modal.Body>
              {/* <Modal.Footer>
                <Button
                  bsStyle=""
                  className="btn btn-custom-white"
                  onClick={this.closeModal}
                >
                  {LocaleStrings.button_close}
                </Button>
                <Button
                  className="btn btn-custom-blue ml-10"
                  bsStyle=""
                  loading={loading}
                  disabled={custPristine || invalid || submitting}
                  type="submit"
                >
                  {LocaleStrings.button_save}
                </Button>
              </Modal.Footer> */}
            </form>
          </Modal>
        </div>
      </div>
    );
  }
}

const selector = formValueSelector("badgeDesignForm");

function mapStateToProps(state) {
  var pagepadding = _.split(PAGEDEFAULTPADDING, "#");
  let initObject = {
    page_padding_top: pagepadding[0],
    page_padding_left: pagepadding[3],
  };

  if (_.isEmpty(state.dataInEditMode)) {
    // add mode
    initObject = {
      ...initObject,
      page_size: PAGEDEFAULTSIZE,
      badge_size: BADGEDEFAULTSIZE,
      badge_elements: ["#event_name", "#full_name", "#qr_code"], // Bydefault selected at the time of add
      measurement: "cm",
    };
  } else {
    // edit mode
    initObject = { ...state.dataInEditMode };
    initObject.badge_elements = _.split(initObject.badge_elements, ",");

    /*
     Note:-  For custom badge size we will take the vlaue in 
      "badge_custom_or_list" (Check will receive props)
      as we can take e.g. 4*3 and "custom" calue toggether 
     */
    // Set "Page default/custom"
    initObject["page_custom_or_list"] = initObject.iscustompage
      ? initObject.page_size
      : "";
    // Set "Badge default/custom"
    initObject["badge_custom_or_list"] = initObject.iscustombadge
      ? initObject.badge_size
      : "";

    // Custom Page value if "Page default/custom" -> custom
    if (initObject.iscustompage) {
      let pageSizeArr = _.split(initObject.page_size, "#"); // Exapmle [4,3]
      initObject["pagewidth"] = pageSizeArr[0];
      initObject["pageheight"] = pageSizeArr[1];

      initObject["page_size"] = "custom";
    }
    if (initObject.page_padding && initObject.page_padding != "") {
      let padding = _.split(initObject.page_padding, "#"); // Exapmle [1.5,0,0,0.64]
      initObject["page_padding_top"] = padding[0] ? padding[0] : 0;
      initObject["page_padding_left"] = padding[3] ? padding[3] : 0;
    }
    // Custom Badge value if "Badge default/custom" -> custom
    if (initObject.iscustombadge) {
      let badgeSizeArr = _.split(initObject.badge_size, "#"); // Exapmle [4,3]
      initObject["badgewidth"] = badgeSizeArr[0];
      initObject["badgeheight"] = badgeSizeArr[1];
      initObject["badge_size"] = "custom";
    }
  }

  return {
    session: state.session,
    user: state.user,
    initialValues: { ...initObject },
    editMode: _.isEmpty(state.dataInEditMode) ? false : true,
    isBadgeDesignModalOpen: state.isBadgeDesignModalOpen, // Badge design modal
    selectedElement: state.selectedElement,
    templateJson: state.templateJson,
    imageElementModal: state.imageElementModal,
    userCategoryList: state.userCategoryList,
    dashboardAllBadgeList: state.dashboardAllBadgeList,

    // form field values
    badgeSize: selector(state, "badge_size"),
    badgewidth: selector(state, "badgewidth"),
    badgeheight: selector(state, "badgeheight"),
    measurementType: selector(state, "measurement"),
  };
}

function validate(values) {
  // console.log("values :- ", values);
  var errors = {};
  var requiredFields = [
    "badgename",
    "page_size",
    "badge_size",
    // "badge_elements",
    "page_padding_top",
    "page_padding_left",
  ];

  if (values && values.page_size && values.page_size === "custom") {
    requiredFields.push("pagewidth", "pageheight");
  }

  if (values && values.badge_size && values.badge_size === "custom") {
    requiredFields.push("badgewidth", "badgeheight");
  }

  /*** Common Validation ***/
  requiredFields.forEach((field) => {
    if (!values[field] || values[field] === "") {
      errors[field] = LocaleStrings.required;
    }
    if (
      (field === "page_padding_top" || field === "page_padding_left") &&
      values[field] &&
      values[field] < 0
    ) {
      errors[field] = LocaleStrings.invalid_value;
    }
    if (
      (field === "badgewidth" || field === "badgeheight") &&
      !validateDecimalNums(values[field])
    ) {
      errors[field] = LocaleStrings.invalid_number;
    }
  });

  if (values.badge_size === "custom" && values.badgewidth < BADGEMINWIDTH) {
    errors["badgewidth"] =
      LocaleStrings.dashboard_badgedesign_custom_badge_min_width;
  }
  if (values.badge_size === "custom" && values.badgeheight < BADGEMINHEIGHT) {
    errors["badgeheight"] =
      LocaleStrings.dashboard_badgedesign_custom_badge_min_height;
  }
  if (values.badge_size === "custom" && values.badgewidth > BADGEMAXWIDTH) {
    errors["badgewidth"] =
      LocaleStrings.dashboard_badgedesign_custom_badge_max_width;
  }
  if (values.badge_size === "custom" && values.badgeheight > BADGEMAXHEIGHT) {
    errors["badgeheight"] =
      LocaleStrings.dashboard_badgedesign_custom_badge_max_height;
  }
  // console.log("errors :- ", errors);
  return errors;
}

export default connect(mapStateToProps, {
  openBadgeDesignModal,
  showError,
  showSuccess,
  fetchEventDetails, //evnet details
  setbadgeJson,
  fetchBadgeList,
  addTemplate,
  updateTemplate,
  getSingleBadgerecord,
  togglePrintPreviewModal,
  setSelectedElement,
  handleImageEleModal,
})(
  reduxForm({
    validate,
    form: "badgeDesignForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(CreateNewDialog)
);
